import { createStore } from 'zustand'

import { promiseNoop } from '@eastcoal/common/utils/promise'

import { HomeStore } from './interface'

export const createHomeStore = () =>
  createStore<HomeStore>((get, set) => ({
    data: [],
    error: undefined,
    loading: false,
    refreshData: promiseNoop,
    currentDocId: undefined,
    currentCatalogues: []
  }))
